import React, { useEffect } from 'react'
import { DashboardContentContainer } from './styles'
import { RadiologySidePanel } from '../sidePanel'
import { RadiologyMainPanel } from '../mainPanel'
import { useSelectedMedicalView } from '~/hooks/useSelectedMedicalView'
import { OpenCloseProvider, usePatient, useRadiologyHealthProcedures } from '~/context'
import { CreateHealthProcedureDetails } from '~/components/healthProcedures/CreateHealthProcedureDetails'

export const RadiologyContent = (): JSX.Element => {
  const { selectedMedicalView } = useSelectedMedicalView()
  const { patient } = usePatient()
  const {
    getHealthProcedures,
    displayedHealthProcedures,
    isLoadingTimeline,
    modalHealthProcedure,
    closeHealthProcedureDetails
  } = useRadiologyHealthProcedures()

  useEffect(() => {
    getHealthProcedures({ pathParams: { patientId: patient.id } }, selectedMedicalView)
  }, [])

  const hasData = (): boolean => {
    return !!(displayedHealthProcedures && displayedHealthProcedures.length > 0)
  }

  const isFetchingHealthProcedures = (): boolean => {
    return isLoadingTimeline
  }

  return (
    <>
      <DashboardContentContainer>
        <OpenCloseProvider>
          <RadiologyMainPanel isLoading={isFetchingHealthProcedures()} hasData={hasData()} />
          <RadiologySidePanel />
        </OpenCloseProvider>
      </DashboardContentContainer>

      <CreateHealthProcedureDetails
        handleSelectedModalHealthProcedures={closeHealthProcedureDetails}
        selectedPatient={() => patient.id}
        modalHealthProcedure={modalHealthProcedure}
      />
    </>
  )
}
